export default __webpack_public_path__ + "static/media/012-porthole.a5d21af3.png";